import { all } from 'redux-saga/effects'

import resetpassword from './resetpassword/sagas'
import auth from './auth/sagas'
import player from './player/sagas'
import dialog from './dialog/sagas'

export default function* rootSaga() {
  return yield all([resetpassword, auth, player, dialog])
}
